import { useUser } from 'contexts/UserContext'
import useModules from 'hooks/useModules'
import { menuSections } from 'data/menuItems'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'wouter'

// Un ítem está activo si la ruta coincide o cuelga de él ('/conversations/123'),
// salvo el inicio '/', que solo se activa en la raíz.
const isActive = (location, slug) =>
  slug === '/' ? location === '/' : location === slug || location.startsWith(`${slug}/`)

export default function Menu({ collapsed, onNavigate }) {
  const { t } = useTranslation()
  const { hasPermission } = useUser()
  const { hasModule } = useModules()
  const [location] = useLocation()

  // Un cliente solo ve las secciones de los módulos que tiene contratados
  const allowed = (entry) =>
    (!entry.requiredPermissions || hasPermission(entry.requiredPermissions)) &&
    (!entry.requiredModules || entry.requiredModules.some(mod => hasModule(mod)))

  const sections = menuSections
    .filter(allowed)
    .map(section => ({ ...section, items: section.items.filter(allowed) }))
    .filter(section => section.items.length > 0)

  return (
    <nav aria-label="Navegación principal" className="flex flex-col gap-5">
      {sections.map((section, index) => (
        <div key={section.title || index} className="flex flex-col gap-0.5">
          {section.title && !collapsed && (
            <span className="px-2.5 pb-1.5 text-xs font-medium text-gray-500">
              {t(section.title)}
            </span>
          )}
          {section.title && collapsed && index > 0 && (
            <span className="mx-2.5 mb-1.5 border-t border-gray-200" aria-hidden="true" />
          )}
          {section.items.map(item => {
            const active = isActive(location, item.slug)
            const label = t(item.title)
            return (
              <Link
                key={item.slug}
                href={item.slug}
                onClick={onNavigate}
                title={collapsed ? label : undefined}
                aria-current={active ? 'page' : undefined}
                className={`flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm transition-colors ${
                  collapsed ? 'justify-center' : ''
                } ${
                  active
                    ? 'bg-brand-soft font-semibold text-brand'
                    : 'font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                {item.icon}
                {!collapsed && <span className="truncate">{label}</span>}
              </Link>
            )
          })}
        </div>
      ))}
    </nav>
  )
}

Menu.propTypes = {
  collapsed: PropTypes.bool,
  onNavigate: PropTypes.func,
}

Menu.defaultProps = {
  collapsed: false,
  onNavigate: undefined,
}
